<template>
  <v-app>
    <notification-list />
    <Navbar v-if="store.user.isAuthenticated" />
    <v-main>
      <transition appear name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NotificationList from "./components/NotificationsList";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  computed: {
    store() {
      return this.$store.state;
    }
  },
  components: {
    NotificationList,
    Footer,
    Navbar,
  },
  created(){
    this.$store.dispatch("InitStore");
  },
};
</script>

<style lang="scss">
// ========TRANSITIONS======== //
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-leave-to {
  opacity: 0;
}
</style>
